import React from "react";
import { Button, Grid } from "@mui/material";
import { Controller, useForm } from "react-hook-form";

import AppForm from "components/Shared/AppForm";
import BaseSelect from "components/Shared/Base/BaseSelect";

import { NOTE_TYPES } from "data/static/staticOptions";
import RichTextEditor from "components/Shared/RichTextEditor";

const INITIAL_STATE = {
  content: "",
  type: "",
};

const CustomerNotesForm = ({
  isBusy = false,
  note = null,
  onSubmit = () => {},
  onCancel = () => {},
}) => {
  // react form hook
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      INITIAL_STATE,
    },
  });

  // methods
  const handleSubmitCustomerNote = async (data) => {
    const _customerNotePayLoad = {
      noteId: note?._id,
      ...data,
    };
    onSubmit(_customerNotePayLoad);
  };

  React.useEffect(() => {
    if (!note) return;
    reset({
      ...INITIAL_STATE,
      ...note,
      type: note?.type || "",
    });
  }, [note, reset]);

  return (
    <AppForm loading={isBusy}>
      <AppForm.Content>
        <Grid container spacing={4}>
          <Grid item md={12}>
            <div
              style={{ color: "gray", fontSize: 15, marginBottom: ".75rem" }}
            >
              Content
            </div>
            <Controller
              name="content"
              control={control}
              rules={{ required: "Content is required" }}
              render={({ field: { onChange } }) => (
                <RichTextEditor
                  initialValue={
                    note?.content ? note.content : "<p>Enter Notes.</p>"
                  }
                  onChange={(value) => {
                    const plainText = value.replace(/<[^>]+>/g, "");
                    onChange(plainText);
                  }}
                  error={!!errors?.content}
                  helperText={errors?.content?.message}
                />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <Controller
              name="type"
              control={control}
              rules={{ required: "Type is required" }}
              render={({ field }) => (
                <BaseSelect
                  {...field}
                  required
                  fullWidth
                  size="small"
                  label="Type"
                  options={NOTE_TYPES}
                  value={field.value || ""}
                  helperText={errors?.type?.message}
                  error={!!errors?.type}
                />
              )}
            />
          </Grid>
        </Grid>
      </AppForm.Content>
      <AppForm.Actions>
        <Button disabled={isBusy} onClick={onCancel}>
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={handleSubmit(handleSubmitCustomerNote)}
        >
          {note ? "Update" : "Add"}
        </Button>
      </AppForm.Actions>
    </AppForm>
  );
};

export default CustomerNotesForm;
